import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';


export enum RESPONSE {
  Save = 'save',
  Cancel = 'cancel'
}


@Component({
  selector: 'ems-query-name',
  templateUrl: './query-name.component.html',
  styleUrls: ['./query-name.component.scss']
})
export class QueryNameComponent implements OnInit {
  public currentNameCtrl = new FormControl()
  public userForm!: FormGroup

  constructor(
    public dialogRef: MatDialogRef<QueryNameComponent>,
    private formBuilder: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: string
  ) { 
    this.dialogRef.disableClose = true
  }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      currentNameCtrl: this.data
    })
    this.currentNameCtrl.setValue(this.data)
  } // ngOnInit()

  public buttonSave(): void {
    this.dialogRef.close({
      event: RESPONSE.Save,
      data: this.currentNameCtrl.getRawValue()
    });
  } // buttonSave()

  public buttonCancel(): void {
    // Issue Close
    this.dialogRef.close({
      event: RESPONSE.Cancel,
      data: undefined
    });
  } // buttonCancel()

} // class QueryNameComponent

